import {
  DOWNLOAD_LEAD_CAPTURE,
  DOWNLOAD_LEAD_CAPTURE_SUCCESS,
  DOWNLOAD_LEAD_CAPTURE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const downloadLeadCaptureReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_LEAD_CAPTURE:
      return { ...state, loading: true };
    case DOWNLOAD_LEAD_CAPTURE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DOWNLOAD_LEAD_CAPTURE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default downloadLeadCaptureReducer;
